import { Event } from "../../contracts";

export const mapIsInFavorites = (favorites: string[], event: Event) => {
    event.isInFavorites = favorites.indexOf(event.id) > -1;
    return event;
}